/**
 * horizontalCard.tsx
 */
import Card from '@shared/types/props/card';
import Container from '@components/atoms/container/horizontalCardContainer';
import Image from '@components/atoms/images/horizontalCardImage';
import Info from '@components/elements/card/ui/info/horizontalCardInfo';
import Mask from '@components/atoms/mask/horizontalCardMask';
import useHorizontalCard from '@components/elements/card/lib/useHorizontalCard';
import { memo } from 'react';

/**
 * Horizontal card component. Represents a single horizontal card in the horizontal rail.
 * Handles lazy loading, focus states, and asset updates on hover.
 *
 * @param {Props} props - Component props including item, index, and onClick handler
 * @returns {JSX.Element | null} Horizontal card element or null if not in view
 */
function HorizontalCard(parentProps: Card) {
  // Card hook
  const { display, props } = useHorizontalCard(parentProps);

  // Render
  return (
    <Container
      id='horizontalCardContainer'
      focused={parentProps.focused}
      hide={parentProps.hide}
      {...props.container}
    >
      <>
        <Image {...props.image} />
        {display.mask ? <Mask /> : null}
        {display.info ? <Info {...props.info} /> : null}
        {parentProps.children}
      </>
    </Container>
  );
}

export default memo(HorizontalCard);
